import type { CSSProperties } from "react";

/** Read by AccountActionsNavItem.module.css (`.navButton:hover`); keep the two in sync. */
export const ACCOUNT_ACTIONS_NAV_ITEM_HOVER_BG_VAR = "--account-actions-nav-item-hover-bg";

/**
 * D01a/D01b — the cast is necessary because `React.CSSProperties` (csstype's
 * `CSS.Properties<string | number>`) declares no index signature for `--*` custom properties, so a
 * style object carrying one cannot be typed without it. It is safe because React writes
 * unrecognized `--*` style keys onto the element verbatim (`CSSStyleDeclaration.setProperty`);
 * `account-actions-nav-item-style.test.ts` renders the object through react-dom and asserts the
 * custom property lands in the emitted `style` attribute.
 */
export const accountActionsNavItemHoverStyle = (hoverBackground: string): CSSProperties =>
  ({ [ACCOUNT_ACTIONS_NAV_ITEM_HOVER_BG_VAR]: hoverBackground }) as CSSProperties;
